import { apiClient } from './client';
import type { Agent, AgentVersion, CreateVersionRequest, UploadResponse } from '../types';

export const agentsApi = {
  // Get all agents for a firm
  getByFirm: async (firmId: number): Promise<Agent[]> => {
    const response = await apiClient.get(`/api/firms/${firmId}/agents`);
    return response.data;
  },

  // Get agent by ID
  getById: async (firmId: number, id: number): Promise<Agent> => {
    const response = await apiClient.get(`/api/firms/${firmId}/agents/${id}`);
    return response.data;
  },

  // Request data fetch for a specific source
  requestFetch: async (firmId: number, agentId: number, sourceId: number): Promise<void> => {
    await apiClient.post(`/api/firms/${firmId}/agents/${agentId}/fetch/${sourceId}`);
  },

  // Delete agent
  delete: async (firmId: number, id: number): Promise<void> => {
    await apiClient.delete(`/api/firms/${firmId}/agents/${id}`);
  },
};

export const agentVersionsApi = {
  // Get all versions
  getAll: async (): Promise<AgentVersion[]> => {
    const response = await apiClient.get('/api/agent-versions');
    return response.data;
  },

  // Get latest version
  getLatest: async (): Promise<AgentVersion | null> => {
    try {
      const response = await apiClient.get('/api/agent-versions/latest');
      return response.data;
    } catch {
      return null;
    }
  },

  // Create new version
  create: async (data: CreateVersionRequest): Promise<AgentVersion> => {
    const response = await apiClient.post('/api/agent-versions', data);
    return response.data;
  },

  // Upload installer file
  upload: async (file: File, version: string): Promise<UploadResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('version', version);

    const response = await apiClient.post('/api/agent-versions/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
